
export const formatDistance = (meters) => {
  if (!meters) return null;

  return meters < 1000
    ? `${Math.round(meters)} m`
    : `${(meters / 1000).toFixed(1)} km`;
};

export const formatAttendanceRow = (row) => {
    let inLocationObj = null;
    let outLocationObj = null;

    const isFaceAttendance = row?.mode === "Face Attendance";
    const isWhatsappAttendance = row?.mode === "Whatsapp Attendance";
    const isLocationMode = isFaceAttendance || isWhatsappAttendance;

    if (isLocationMode && typeof row?.in_location_name === "string" && row.in_location_name) {
        try {
            inLocationObj = JSON.parse(row.in_location_name);
        } catch {
            inLocationObj = null;
        }
    }

    if (isLocationMode && typeof row?.out_location_name === "string" && row.out_location_name) {
        try {
            outLocationObj = JSON.parse(row.out_location_name);
        } catch {
            outLocationObj = null;
        }
    }
    const inDisplayName = inLocationObj?.displayName || "";
    const inDistance = inLocationObj?.coordinateDiff
        ? formatDistance(inLocationObj.coordinateDiff)
        : null;

    const outDisplayName = outLocationObj?.displayName || "";
    const outDistance = outLocationObj?.coordinateDiff
        ? formatDistance(outLocationObj.coordinateDiff)
        : null;

    return {
        ...row,
        in_mode: isFaceAttendance
            ? row?.in_location
                ? "App Attendance"
                : row?.in_time
                    ? "Face Attendance"
                    : "-"
            : isWhatsappAttendance
                ? row?.in_time
                    ? "Whatsapp Attendance"
                    : "-"
                : row?.mode,

        out_mode: isFaceAttendance
            ? row?.out_location
                ? "App Attendance"
                : row?.out_time
                    ? "Face Attendance"
                    : "-"
            : isWhatsappAttendance
                ? row?.out_time
                    ? "Whatsapp Attendance"
                    : "-"
                : row?.mode,

        in_location_display_name: isLocationMode ? inDisplayName : "",
        in_location_distance: isLocationMode ? inDistance : null,

        out_location_display_name: isLocationMode ? outDisplayName : "",
        out_location_distance: isLocationMode ? outDistance : null,
        is_face_attendance: isLocationMode,
    };
};